module.exports = __webpack_public_path__ + "static/img/platphom12.60ed85e1.png";